var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInformerIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 57,
  height: 56,
  viewBox: "0 0 57 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#svg-public/img/icons/documents/informer_icon.svg__clip0)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#svg-public/img/icons/documents/informer_icon.svg__filter0_f)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.2242 24.5205C25.4446 22.247 32.2686 22.247 38.489 24.5205L39.0966 24.7426C40.2373 25.1595 41.167 26.0103 41.6831 27.1096C44.327 32.7417 44.327 39.2583 41.6831 44.8904C41.167 45.9897 40.2373 46.8405 39.0966 47.2574L38.489 47.4795C32.2686 49.753 25.4446 49.753 19.2242 47.4795L18.6165 47.2574C17.4758 46.8405 16.5462 45.9897 16.0301 44.8904C13.3862 39.2583 13.3862 32.7417 16.0301 27.1096C16.5462 26.0103 17.4758 25.1595 18.6165 24.7426L19.2242 24.5205Z",
  fill: "#7E1FD8",
  fillOpacity: 0.5
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#svg-public/img/icons/documents/informer_icon.svg__filter1_i)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.0778 6.17732C27.0835 4.80787 30.6297 4.80787 33.6354 6.17732C37.0752 7.74459 40.4242 9.63106 43.5418 11.7686L43.6789 11.8626C46.3459 13.6912 48.0577 16.6148 48.3473 19.8355C48.6861 23.6042 48.6861 27.3958 48.3473 31.1645C48.0577 34.3852 46.3459 37.3088 43.6789 39.1374L43.5418 39.2314C40.4242 41.3689 37.0752 43.2554 33.6354 44.8227C30.6297 46.1921 27.0835 46.1921 24.0778 44.8227C20.6379 43.2554 17.2889 41.3689 14.1713 39.2314L14.0343 39.1374C11.3672 37.3088 9.65539 34.3852 9.36583 31.1645C9.027 27.3958 9.027 23.6042 9.36583 19.8355C9.65539 16.6148 11.3672 13.6912 14.0343 11.8626L14.1713 11.7686C17.2889 9.63105 20.6379 7.74459 24.0778 6.17732Z",
  fill: "url(#svg-public/img/icons/documents/informer_icon.svg__paint0_linear)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#svg-public/img/icons/documents/informer_icon.svg__filter2_bd)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 20.8566,
  y: 16.2444,
  width: 16,
  height: 19,
  rx: 2,
  fill: "url(#svg-public/img/icons/documents/informer_icon.svg__paint1_linear)",
  fillOpacity: 0.99
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "svg-public/img/icons/documents/informer_icon.svg__filter0_f",
  x: 6.04712,
  y: 14.8154,
  width: 45.6189,
  height: 42.3692,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "svg-public/img/icons/documents/informer_icon.svg__filter1_i",
  x: 9.11169,
  y: 5.15024,
  width: 39.4897,
  height: 41.6995,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "svg-public/img/icons/documents/informer_icon.svg__filter2_bd",
  x: 16.8566,
  y: 14.2444,
  width: 24,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.365555 0 0 0 0 0.0769736 0 0 0 0 0.691927 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_backgroundBlur",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-public/img/icons/documents/informer_icon.svg__paint0_linear",
  x1: 31.8195,
  y1: 10.1642,
  x2: 31.7929,
  y2: 43.8882,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9058FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7D1BD6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-public/img/icons/documents/informer_icon.svg__paint1_linear",
  x1: 28.8566,
  y1: 16.2444,
  x2: 28.8566,
  y2: 35.2444,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D8C5E1"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "svg-public/img/icons/documents/informer_icon.svg__clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 50,
  height: 56,
  fill: "white",
  transform: "translate(3.85657)"
})))));
export { SvgInformerIcon as ReactComponent };